import { Typography, Box } from "@mui/material";

const Header = ({ title, subtitle }) => {
  return (
    <Box className="page-heading" mb={2.5}>
      <Typography
        variant="h1"
        color="text.primary"
        fontWeight="700"
        sx={{
          m: "0 0 5px 0",
          letterSpacing: 0,
        }}
      >
        {title}
      </Typography>
      <Box display="flex" alignItems="center" gap="10px">
        <Typography variant="body2" color="text.secondary">
          {subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
